const ITEMS = [
  "Employer of Record",
  "Dedicated Offshore Development Centre",
  "Centre of Excellence",
  "Global Capability Centre",
  "A Lionforce Company",
  "Chennai · India",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      aria-hidden="true"
      className="relative -mt-8 rounded-t-[48px] py-14 bg-white overflow-hidden select-none"
      data-testid="editorial-marquee"
    >
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-[#5B4199]/[0.16] px-7">
                  {item}
                </span>
                <span className="h-2 w-2 rounded-full bg-[#5B4199]/30" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
